import { render, staticRenderFns } from "./UiShowFees.vue?vue&type=template&id=c63aa312&lang=pug&"
import script from "./UiShowFees.vue?vue&type=script&lang=js&"
export * from "./UiShowFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports